// Typelizer digest 2ca964c87fc9651741ce584e6ad92966
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET / */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/', {}, options),
    method: 'get',
  }),
}
